import { Flame } from "lucide-react";
import { ADDRESS, PHONE_DISPLAY, PHONE_TEL } from "@/data";

export default function Footer() {
  return (
    <footer className="border-t border-zinc-800" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 pt-20 pb-10">
        <div className="flex flex-col lg:flex-row justify-between gap-10 mb-16">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <Flame className="w-6 h-6 text-ember" />
              <span className="font-display text-4xl tracking-wide">AVANTI PIZZA & KEBAB</span>
            </div>
            <p className="text-zinc-500 text-sm max-w-xs">Charcoal-fired pizza, kebabs and snack packs in the heart of Mildura.</p>
          </div>
          <div className="font-mono text-xs tracking-[0.2em] uppercase text-zinc-500 space-y-3">
            <p>{ADDRESS}</p>
            <a href={PHONE_TEL} className="block text-ember hover:text-ink transition-colors duration-300" data-testid="footer-phone-link">
              {PHONE_DISPLAY}
            </a>
            <p>Open 7 days · Till late</p>
          </div>
        </div>
        <div className="overflow-hidden" aria-hidden="true">
          <p className="font-display text-[24vw] lg:text-[18rem] leading-[0.8] text-center text-stroke-ember select-none">AVANTI</p>
        </div>
        <p className="mt-10 font-mono text-[10px] tracking-[0.2em] uppercase text-zinc-700 text-center">
          © {new Date().getFullYear()} Avanti Pizza & Kebab · Mildura VIC ·{" "}
          <a href="/owner" className="hover:text-ember transition-colors duration-300" data-testid="footer-owner-link">Owner Login</a>
        </p>
      </div>
    </footer>
  );
}
